import { Link } from "react-router-dom";
import "./Upload.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const Upload = () => {
  const { id } = useParams();

  return (
    <>
      <ContentWrapper>
        <Container fluid className=" pt-5 pb-5" style={{ minHeight: "88.7vh" }}>
          <Row>
            <Col md={8} className="mx-auto text-center upload-video pt-5 pb-5">
              <h1 className="text-primary">
                <FontAwesomeIcon icon={faFileUpload} />
              </h1>
              <h4 className="mt-5">انتخاب فایل</h4>
              {/*	<p className="land">or drag and drop video files</p>*/}
              <div className="mt-4">
                <Link
                  style={{ width: "fit-content" }}
                  className="btn btn-outline-primary"
                  to={`/upload-video/${id}/`}
                >
                  بارگزاری ویدئو
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
        <ThinFooter />
      </ContentWrapper>
    </>
  );
};

export default Upload;
